var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 3.5A2.5 2.5 0 0 1 6.5 1H16a2.5 2.5 0 0 1 2.5 2.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 0 16 2H6.5A1.5 1.5 0 0 0 5 3.5v1h.5a.5.5 0 0 1 0 1H5v2h.5a.5.5 0 0 1 0 1H5v2h.5a.5.5 0 0 1 0 1H5v2h.5a.5.5 0 0 1 0 1H5v2h.5a.5.5 0 0 1 0 1H5v1A1.5 1.5 0 0 0 6.5 20h9a.5.5 0 0 1 0 1H11v2l-2-1.5L7 23v-2h-.5A2.5 2.5 0 0 1 4 18.5v-1h-.5a.5.5 0 0 1 0-1H4v-2h-.5a.5.5 0 0 1 0-1H4v-2h-.5a.5.5 0 0 1 0-1H4v-2h-.5a.5.5 0 0 1 0-1H4v-2h-.5a.5.5 0 0 1 0-1H4zm4.5 1a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM8 7a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 8 7m.5 1.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm9 0a.5.5 0 0 1 1 0v1h-1zm0 2V14h1v-3.5zm.01 4.5c.038.93.168 2.134.334 3.171.05.313.102.606.156.87a29.029 29.029 0 0 0 .49-4.04zM18 7a1.5 1.5 0 0 0-1.5 1.5v6c0 1.036.154 2.564.356 3.829.101.633.217 1.216.337 1.648.059.213.125.41.199.565.036.074.086.165.157.244.06.068.211.214.451.214s.391-.146.451-.214c.07-.08.121-.17.157-.244.074-.154.14-.352.199-.565.12-.432.236-1.015.337-1.648.202-1.265.356-2.793.356-3.829v-4.117q.027.03.053.062c.268.322.447.712.447 1.055v3a.5.5 0 0 0 1 0v-3c0-.657-.321-1.267-.678-1.695a2.9 2.9 0 0 0-.6-.55 2 2 0 0 0-.222-.128V8.5A1.5 1.5 0 0 0 18 7",
    clipRule: "evenodd"
  })));
});
const SvgNoteBook = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoteBook);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "4384c69f03f4a65c9ee3e014692d891a.svg";